import React from 'react';
import { createComponent } from '@lit/react';
import { IxSelect as IxSelectLit } from '../IxSelect.js';

customElements.define('ix-select', IxSelectLit);

export const IxSelect = createComponent({
  tagName: 'ix-select-react',
  elementClass: IxSelectLit,
  react: React,
  events: {
    onclick: 'onClick',
  },
});
